import {Component, ElementRef} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationUser } from './../../services/ApplicationUser';
declare var $: JQueryStatic | any;

import 'jquery-serializejson';
import 'jquery-validation';
import {ToasterService} from "angular2-toaster";
import {AuthService} from "../../models/auth/auth.service";
import {LoginModel} from "../../models/auth/auth.model";
import {ValidationService} from "../../services/validation.service";
import {LastUrl} from '../../services/LastRouteService';


@Component({
    selector: 'login',
    templateUrl: 'login.template.html',
    styleUrls: ['login.css']
})
export class loginComponent {
    public year = new Date().getFullYear();

    public model = new LoginModel();

    public $loginForm: any;

    public passRestored: boolean = false;

    private _in_process = false;

    constructor(
        private router: Router,
        protected el: ElementRef,
        private toasterService: ToasterService,
        private authService: AuthService,
        protected validationService: ValidationService,
        private route: ActivatedRoute
    ) {
        const user = ApplicationUser.getInstance();
        if (user.loggedIN) {
            this.router.navigate(['/']);
            return;
        }
    }

    ngAfterViewInit() {
        this.$loginForm = $('[name="login-form"]', this.el.nativeElement);
        this.validateForm();
    }

    // ===========================================================
    // Actions
    // ===========================================================



    // ===========================================================
    // Functions
    // ===========================================================

    private validateForm() {
        //this.$loginForm.find('input,select').prop('required', true);

        this.$loginForm
            .validate({
                submitHandler: (form) => {
                    if (this._in_process) return;
                    this._in_process = true;

                    this.$loginForm.find('input,button').prop("disabled", true);
                    this.authService.login(this.model)
                        .then(() => {
                            this._in_process = false;
                            this.$loginForm.find('input,button').prop("disabled", false);
                            this.router.navigate([LastUrl.lastUrl]);
                        })
                        .catch((error) => {
                            this._in_process = false;
                            this.$loginForm.find('input,button').prop("disabled", false);
                            this.validationService.showError(error, form);
                        });
                }
            });
    }

    get isValidEmail() {
        try {
            let reg = /^[\s]*[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?[\s]*$/g;
            return reg.test(this.model.email);
        } catch (e) {
            return false;
        }
    }

    get isValidPass() {
        try {
            return this.model.password.length > 0.1;
        } catch (e) {
            return false;
        }
    }

    get isLoginReady() {
        return this.isValidEmail && this.isValidPass;
    }

    restorePass() {
        if (this._in_process) return;
        this._in_process = true;

        this.$loginForm.find('input,button').prop("disabled", true);
        this.authService.restoreLogin(this.model)
            .then(() => {
                this._in_process = false;
                this.$loginForm.find('input,button').prop("disabled", false);
                this.passRestored = true;
                this.model.email = '';
                this.model.password = '';
            })
            .catch((error) => {
                this._in_process = false;
                this.$loginForm.find('input,button').prop("disabled", false);
                this.validationService.showError(error, this.$loginForm);
            });
    }
}




// WEBPACK FOOTER //
// ./src/app/views/login/login.component.ts